import { useState } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { isInternalApp } from '../../utils/appsWithHiddenStatuses';
import { getOptions } from './utils/getOptions';
import { AuthorizationStatusPopover } from './AuthorizationStatusPopover';
import { jsx as _jsx } from "react/jsx-runtime";
export const AuthorizationStatusView = ({
  accountStatusesList = [],
  alertStore,
  error,
  loading = false,
  onAuthSucceeded,
  showInstalledStatus,
  showPopover = true,
  tracker
}) => {
  var _accountStatusesList$;
  const authStatuses = accountStatusesList.filter(status => {
    return status.metadata.category === 'AUTHORIZATION';
  });
  const [popoverOpen, setPopoverOpen] = useState(undefined);
  const {
    popoverDisabled,
    popoverHeadingText,
    popoverMessage,
    content,
    ctaButton
  } = getOptions({
    accountStatusesList: authStatuses,
    alertStore,
    loading,
    setPopoverOpen,
    showInstalledStatus,
    onAuthSucceeded,
    tracker
  });
  const appId = (_accountStatusesList$ = accountStatusesList[0]) === null || _accountStatusesList$ === void 0 ? void 0 : _accountStatusesList$.appId;
  if (isInternalApp(appId)) {
    return null;
  }
  if (error || !content) {
    return null;
  }
  return /*#__PURE__*/_jsx(TFlex, {
    align: "center",
    minBlockSize: "36px",
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      showResult: false,
      grow: false,
      size: "xs",
      layout: "centered",
      minInlineSize: "100px"
    }) : /*#__PURE__*/_jsx(AuthorizationStatusPopover, {
      ctaButton: ctaButton,
      disabled: !showPopover || popoverDisabled,
      headingText: popoverHeadingText,
      message: popoverMessage,
      open: popoverOpen,
      children: content
    })
  });
};